import { AllowancesByClasses } from 'app/dataTypes/reports/data/common/ordersByClasses'

export enum ColumnKey {
  Org = 'org',
  OrgGhost = 'orgGhost',
  CountFrom1To4 = 'countFrom1To4',
  ParentsExpensesFrom1To4 = 'parentsExpensesFrom1To4',
  TotalFrom1To4 = 'totalFrom1To4',
  CountFrom5To11 = 'countFrom5To11',
  ParentsExpensesFrom5To11 = 'parentsExpensesFrom5To11',
  TotalFrom5To11 = 'totalFrom5To11',
  TotalRow = 'total',
}

export const createDinamicColumnKey = (classesKey: string, allowance: string) => {
  return `${classesKey}_${allowance.replace(/\s/g, '_')}`
}

export const columnKeysLeft = [ColumnKey.Org]
export const createColumnKeysLeftHeaders = (hasAllowances: boolean) => {
  return hasAllowances ? [columnKeysLeft, [ColumnKey.OrgGhost]] : [columnKeysLeft]
}

export const createColumnKeysMain = (allowances: AllowancesByClasses) => {
  return [
    ColumnKey.ParentsExpensesFrom1To4,
    ...(allowances.countFrom1To4
      ? allowances.countFrom1To4.map((allowance) =>
          createDinamicColumnKey('countFrom1To4', allowance),
        )
      : []),
    ColumnKey.TotalFrom1To4,
    ColumnKey.ParentsExpensesFrom5To11,
    ...(allowances.countFrom5To11
      ? allowances.countFrom5To11.map((allowance) =>
          createDinamicColumnKey('countFrom5To11', allowance),
        )
      : []),
    ColumnKey.TotalFrom5To11,
    ColumnKey.TotalRow,
  ]
}

export const createColumnKeysMainHeaders = (allowances: AllowancesByClasses) => {
  return [
    [ColumnKey.CountFrom1To4, ColumnKey.CountFrom5To11, ColumnKey.TotalRow],
    [
      ColumnKey.ParentsExpensesFrom1To4,
      ...allowances.countFrom1To4.map((allowance) =>
        createDinamicColumnKey('countFrom1To4', allowance),
      ),
      ColumnKey.TotalFrom1To4,
      ColumnKey.ParentsExpensesFrom5To11,
      ...allowances.countFrom5To11.map((allowance) =>
        createDinamicColumnKey('countFrom5To11', allowance),
      ),
      ColumnKey.TotalFrom5To11,
    ],
  ]
}

const headerCells = {
  [ColumnKey.Org]: 'Заведение',
  [ColumnKey.OrgGhost]: '',
  [ColumnKey.CountFrom1To4]: 'Количество питающихся по категорим, 1–4 классы',
  [ColumnKey.CountFrom5To11]: 'Количество питающихся по категорим, 5–11 классы',
  [ColumnKey.ParentsExpensesFrom1To4]: 'За родительскую плату',
  [ColumnKey.ParentsExpensesFrom5To11]: 'За родительскую плату',
  [ColumnKey.TotalFrom1To4]: 'ИТОГО',
  [ColumnKey.TotalFrom5To11]: 'ИТОГО',
  [ColumnKey.TotalRow]: 'ВСЕГО',
}

export const createHeaderCells = (allowances: AllowancesByClasses) => {
  return Object.keys(allowances).reduce(
    (acc, key) => {
      allowances[key as keyof AllowancesByClasses].forEach((allowance) => {
        const cKey = createDinamicColumnKey(key, allowance)
        acc[cKey] = allowance
      })
      return acc
    },
    { ...headerCells },
  )
}

const getHeaderCellsProps = (allowances: AllowancesByClasses) => {
  const rowSpan = !!Object.values(allowances).some((array) => array.length > 0) ? 2 : 1
  const colSpanFrom1To4 = allowances.countFrom1To4.length ? allowances.countFrom1To4.length + 2 : 2
  const colSpanFrom5To11 = allowances.countFrom5To11.length
    ? allowances.countFrom5To11.length + 2
    : 2
  return {
    [ColumnKey.Org]: { alignLeft: true, width: 200, rowSpan, bgFilled: true },
    [ColumnKey.OrgGhost]: { alignLeft: true, width: 0, stripPadding: true, bgFilled: true },
    [ColumnKey.ParentsExpensesFrom1To4]: {
      alignRight: true,
      borderRight: true,
      ignoreFirstChild: true,
      bgFilled: true,
    },
    [ColumnKey.ParentsExpensesFrom5To11]: {
      alignRight: true,
      borderRight: true,
      ignoreFirstChild: true,
      bgFilled: true,
    },
    [ColumnKey.CountFrom1To4]: {
      alignCenter: true,
      borderRight: true,
      colSpan: colSpanFrom1To4,
      bgFilled: true,
    },
    [ColumnKey.CountFrom5To11]: {
      alignCenter: true,
      borderRight: true,
      colSpan: colSpanFrom5To11,
      bgFilled: true,
    },
    [ColumnKey.TotalFrom1To4]: {
      alignRight: true,
      borderRight: true,
      ignoreLastChild: true,
      bgFilled: true,
    },
    [ColumnKey.TotalFrom5To11]: {
      alignRight: true,
      borderRight: true,
      ignoreLastChild: true,
      bgFilled: true,
    },
    [ColumnKey.TotalRow]: { alignRight: true, rowSpan, bgFilled: true },
  }
}

export const createHeaderCellsProps = (allowances: AllowancesByClasses) => {
  return Object.keys(allowances).reduce((acc, key) => {
    allowances[key as keyof AllowancesByClasses].forEach((allowance) => {
      const cKey = createDinamicColumnKey(key, allowance)
      acc[cKey] = {
        alignRight: true,
        borderRight: true,
        bgFilled: true,
      }
    })
    return acc
  }, getHeaderCellsProps(allowances))
}

const cellsProps = {
  [ColumnKey.Org]: { alignLeft: true, width: 200 },
  [ColumnKey.ParentsExpensesFrom1To4]: {
    alignRight: true,
    borderRight: true,
    ignoreFirstChild: true,
  },
  [ColumnKey.ParentsExpensesFrom5To11]: { alignRight: true, borderRight: true },
  [ColumnKey.TotalFrom1To4]: { alignRight: true, borderRight: true },
  [ColumnKey.TotalFrom5To11]: { alignRight: true, borderRight: true },
  [ColumnKey.CountFrom1To4]: { alignRight: true, borderRight: true },
  [ColumnKey.CountFrom5To11]: { alignRight: true, borderRight: true },
  [ColumnKey.TotalRow]: { alignRight: true },
}

export const createCellsProps = (allowances: AllowancesByClasses) => {
  let index = 0
  return Object.keys(allowances).reduce(
    (acc, key) => {
      ;(allowances[key as keyof AllowancesByClasses] || []).forEach((allowance) => {
        const cKey = createDinamicColumnKey(key, allowance)
        acc[cKey] = {
          alignRight: true,
          ignoreFirstChild: index === 0,
          borderRight: true,
        }
        index += 1
      })
      return acc
    },
    { ...cellsProps },
  )
}

const totalCellsProps = {
  [ColumnKey.Org]: { alignRight: true, width: 200, bold: true },
  [ColumnKey.ParentsExpensesFrom1To4]: {
    alignRight: true,
    highlighted: true,
    bold: true,
    ignoreFirstChild: true,
    borderRight: true,
  },
  [ColumnKey.ParentsExpensesFrom5To11]: {
    alignRight: true,
    highlighted: true,
    bold: true,
    ignoreFirstChild: true,
    borderRight: true,
  },
  [ColumnKey.TotalFrom1To4]: {
    alignRight: true,
    highlighted: true,
    borderRight: true,
    bold: true,
  },
  [ColumnKey.TotalFrom5To11]: {
    alignRight: true,
    highlighted: true,
    borderRight: true,
    bold: true,
  },
  [ColumnKey.CountFrom1To4]: {
    alignRight: true,
    highlighted: true,
    borderRight: true,
    bold: true,
  },
  [ColumnKey.CountFrom5To11]: {
    alignRight: true,
    highlighted: true,
    borderRight: true,
    bold: true,
  },
  [ColumnKey.TotalRow]: { alignRight: true, highlighted: true, bold: true },
}

export const createTotalCellProps = (allowances: AllowancesByClasses) => {
  return Object.keys(allowances).reduce(
    (acc, key) => {
      ;(allowances[key as keyof AllowancesByClasses] || []).forEach((allowance) => {
        const cKey = createDinamicColumnKey(key, allowance)
        acc[cKey] = {
          alignRight: true,
          highlighted: true,
          borderRight: true,
          bold: true,
        }
      })
      return acc
    },
    { ...totalCellsProps },
  )
}
